import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import "@/App.css";

export default function App() {
  return <BrowserRouter><Routes><Route path="/" element={<HomePage />} /><Route path="/admin" element={<AdminPage />} /></Routes><Toaster position="top-center" toastOptions={{ style: { background: "#1a1a1c", color: "#faf8f5", border: "1px solid rgba(212,175,55,.35)" } }} /></BrowserRouter>;
}
